import { SiteSectionSlug } from './siteSectionSlug';

type WebsiteTag = {
	[key in SiteSectionSlug]: {
		tag: string;
	};
};

// Tag refers to the contentful tag added to page sections for each specific website
export const websiteTag: WebsiteTag = {
	[SiteSectionSlug.MCO]: {
		tag: 'web-mco',
	},
	[SiteSectionSlug.BUSINESS]: {
		tag: 'web-business',
	},
	[SiteSectionSlug.ORL]: {
		tag: 'web-orl',
	},
	[SiteSectionSlug.MCOCARES]: {
		tag: 'web-mcocares',
	},
};
